import { PlatForm } from 'src/app/data/constants/platform.enums';

/**
 * Base environment config is extended by all environment files, all configs are based on dev environment.
 * If you are making change aross all environments you can modify the settings here.
 * Otherwise please overwrite the settings in specific environment file.
 */
export const baseEnvironment = {
    production: false,
    productName: 'Mediacorp AdDirect',
    platform: PlatForm.MediaCorp,
    contactEmail: 'addirect@mediacorp.com.sg',
    disableUserCreation: false,
    prodUat: false,
    enableDiscountFeature: true,

    /**
     * api urls
     */
    apiUrl: '',
    campaignUrl: '',
    campaignDashboardUrl: '',
    helpUrl: 'https://amobeehelp.zendesk.com/hc/en-us/categories/360004766252-Mediacorp-AdDirect-for-Advertisers',
    agencyHelpUrl: 'https://amobeehelp.zendesk.com/hc/en-us/categories/360004883751-Mediacorp-AdDirect-for-SME-Agencies',
    passwordHelpUrl: 'https://amobeehelp.zendesk.com/hc/en-us/categories/360004797972-Troubleshooting',

    /**
    * values used for plan and campaign creation
    */
    // this flag will load customerId, brandId, and advertiserId from API
    loadCBA: true,
    platformClientId: 1248,
    sellerId: 1247,
    customerId: 7947,
    advertiserId: 48030,
    brandId: 114157,
    timezone: 'Asia/Singapore',
    timezoneAbbr: 'SGT',
    defaultCountryId: 20,

    /**
     * payment info
     */
    paymentUrl: '//test-gateway.mastercard.com/checkout/version/62/checkout.js',
    merchantId: 'TEST168900001215',
    merchantName: 'Mediacorp Pte. Ltd.',
    paymentAddress1: '1 Stars Avenue,',
    paymentAddress2: 'Singapore 138507',
    gst: 0.08,
    currency: 'SGD',
    currencySymbol: 'S$',
    currencyId: 9,

    /**
     * s3 info
     */
    s3BucketName: 'amobee-tvvideoassets',
    s3BucketRegion: 'us-west-1',
    s3UseAccelerateEndpoint: false,
    s3BucketFilePath: 'Dev/Creatives/BuyerCreative/',
    s3TemporaryCredentialsEndpoint: 'https://app001.qa1.turn.com:8443/aws/s3external/getCredentials',
};

/**
 * recaptcha info
 */
export const baseRecaptcha = {
    // Only available for tvbuying-sandbox.amobee.com, local.turn.com, localhost
    siteKey: '6LcWy9gZAAAAADzENdmSk18lzXglMu9QcXdCKLrH',
    // v3 with programmatically invoke the challenge will require render for site key
    render: '6LcWy9gZAAAAADzENdmSk18lzXglMu9QcXdCKLrH',
    enterprise: true,
    disabled: false
};